import { motion } from "framer-motion";

const ChiappellaVision = () => {
  return (
    <section
      id="jugada"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(217 61% 10%), hsl(215 48% 20%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        {/* Eyebrow */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-6"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase"
            style={{ color: "#5BA3E0" }}
          >
            La Jugada
          </span>
        </motion.div>

        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white text-center leading-[1.1] mb-12"
        >
          Estás por construir lo único
          <br />
          <span style={{ color: "#5BA3E0" }}>
            que un competidor no te puede copiar.
          </span>
        </motion.h2>

        {/* Paragraphs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="space-y-6 text-base md:text-lg text-white/80 leading-relaxed mb-16"
        >
          <p>
            Vos mismo lo describiste: cualquiera puede tener miles de entidades
            financieras detrás. Pero el que conquista al usuario conquista el
            mercado, y después los demás jugadores te miran a vos, miran qué
            hacés, para poder replicarlo.
          </p>
          <p>
            La plataforma se puede replicar. La tecnología se puede igualar. El
            capital, alguien siempre va a tener más. Lo único que no se copia es
            que vos seas la voz de la pyme real, el que habla de la calle
            cuando todos los demás hablan de la Macro.
          </p>
        </motion.div>

        {/* Display quote */}
        <motion.blockquote
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="font-display italic text-center text-2xl md:text-4xl lg:text-[2.75rem] leading-snug my-16 px-4"
          style={{ color: "#5BA3E0" }}
        >
          “Un competidor con más capital puede copiar tu plataforma.<br />
          Lo que no puede copiar es que seas la voz creíble de la pyme real.”
        </motion.blockquote>

        {/* Closing */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-base md:text-lg text-white/80 leading-relaxed text-center max-w-3xl mx-auto"
        >
          Esa autoridad no se compra. Y es exactamente lo que estás por
          construir.
        </motion.p>
      </div>
    </section>
  );
};

export default ChiappellaVision;
